import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { Alert, Button, Card, Checkbox, Col, Form, Input, Row, Space } from "antd";
import { useApplicationContext } from "components/Application";
import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const signInAccountMutation = gql`
  mutation($input: SignInAccountInput!) {
    signInAccount(input: $input) {
      token
    }
  }
`;

interface FieldData {
  name: string;
  errors: string[];
}

export const SignIn: React.FC<{}> = () => {
  const [form] = Form.useForm();
  const [otherErrors, setOtherErrors] = useState<string[]>([]);
  const { setSessionToken } = useApplicationContext();

  const [execMutation, { loading }] = useMutation(signInAccountMutation, {
    errorPolicy: "none",
    onError: ({ graphQLErrors }) => {
      const fieldsErrors: FieldData[] = [];
      const otherErrors: string[] = [];
      graphQLErrors.forEach((graphQLError) => {
        if (graphQLError.name) {
          fieldsErrors.push({ name: graphQLError.name, errors: (graphQLError as any).messages });
        } else {
          otherErrors.push(graphQLError.message);
        }
      });
      form.setFields(fieldsErrors);
      setOtherErrors(otherErrors);
    },
    onCompleted: (data) => {
      setSessionToken(data?.signInAccount?.token, form.getFieldValue("persistent"));
    },
  });

  const onFinish = (values: any) => {
    execMutation({ variables: { input: values } });
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: "80vh" }}>
      <Col span={16}>
        <Card
          className="login-form"
          cover={<img src="/images/sign-in-logo.png" alt="PGN International" className="logo-auth" />}
          style={{ margin: "0 auto" }}
        >
          {otherErrors.length > 0 && (
            <Space direction="vertical" style={{ marginBottom: "10px" }}>
              {otherErrors.map((otherError, index) => (
                <Alert key={index} type="error" message="Error" description={otherError} />
              ))}
            </Space>
          )}

          <Form form={form} initialValues={{ persistent: true }} onFinish={onFinish}>
            <Form.Item name="email" rules={[{ required: true, message: "is required" }]}>
              <Input prefix={<UserOutlined />} placeholder="Email" autoComplete="username" autoCapitalize="none" />
            </Form.Item>

            <Form.Item name="password" rules={[{ required: true, message: "is required" }]}>
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                autoComplete="current-password"
                autoCapitalize="none"
              />
            </Form.Item>

            <Form.Item>
              <Form.Item
                name="persistent"
                rules={[{ required: true, message: "is required" }]}
                valuePropName="checked"
                noStyle
              >
                <Checkbox>Remember me</Checkbox>
              </Form.Item>

              <Link to="/auth/password-reset" className="login-form-forgot">
                Forgot password
              </Link>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
                Log in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
